/**
 * View component for /user-nodes
 *
 * Generic userNode list view. Defaults to 'all' with:
 * this.props.dispatch(userNodeActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userNodeActions from '../userNodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userNode components
import UserNodeLayout from '../components/UserNodeLayout.js.jsx';
import UserNodeListItem from '../components/UserNodeListItem.js.jsx';

// import userNode css modules
import userNodeStyles from '../userNodeModuleStyles.css';

class UserNodeList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(userNodeActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { userNodeStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the userNodeList meta info here so we can reference 'isFetching'
    const userNodeList = userNodeStore.lists ? userNodeStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual userNode objetcs
     */
    const userNodeListItems = userNodeStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !userNodeListItems || !userNodeList;

    return (
      <UserNodeLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> User Node List
                <Link className="yt-btn small u-pullRight" to={'/user-nodes/new'}> NEW User Node </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (userNodeListItems && userNodeList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userNodeList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {userNodeListItems.map((userNode, i) =>
                      <UserNodeListItem key={userNode._id + i} userNode={userNode} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </UserNodeLayout>
    )
  }
}

UserNodeList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userNodeStore: store.userNode
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserNodeList)
);



// WEBPACK FOOTER //
// modules/userNode/views/UserNodeList.js.jsx